import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./Styles/ProductNotForSale.css";

const CollabProduct = (props) => {
  const { item } = props;

  // Normalize to an images array (supports legacy single `image` field).
  const images =
    Array.isArray(item.images) && item.images.length > 0
      ? item.images
      : item.image
      ? [item.image]
      : [];

  const [showPreview, setShowPreview] = useState(false);
  const [mainIndex, setMainIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState(0);

  const cardStyle = {
    width: "200px",
    height: "300px",
    overflow: "hidden",
  };

  const imageStyle = {
    objectFit: "cover",
    height: "50%",
    transition: "transform 0.3s ease-in-out",
    cursor: "pointer",
  };

  const openPreview = () => {
    setMainIndex(0);
    setShowPreview(true);
  };

  return (
    <>
      <div className="row row-cols-1 row-cols-md-4 g-4">
        <div className="col">
          <div className="card" style={cardStyle}>
            <img
              src={images[hoverIndex] || images[0]}
              className="card-img-top"
              alt={item.name}
              style={imageStyle}
              onClick={openPreview}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "scale(1.1)";
                if (images.length > 1) setHoverIndex(1);
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                setHoverIndex(0);
              }}
            />
            <div className="card-body">
              <h5 className="card-title">{item.name}</h5>
              <div
                className="card-text font-size-text-card notsale-card-description"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
              <button
                type="button"
                className="btn btn-link p-0 notsale-preview-button"
                onClick={openPreview}
              >
                Preview{images.length > 1 ? ` (${images.length} photos)` : ""}
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showPreview} onHide={() => setShowPreview(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{item.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {images.length > 0 && (
            <div className="notsale-preview-gallery">
              <img
                className="notsale-preview-main"
                src={images[mainIndex]}
                alt={`${item.name} ${mainIndex + 1}`}
              />
              {images.length > 1 && (
                <div className="notsale-preview-thumbs">
                  {images.map((img, idx) => (
                    <img
                      key={idx}
                      src={img}
                      alt={`${item.name} thumbnail ${idx + 1}`}
                      className={
                        idx === mainIndex
                          ? "notsale-preview-thumb selected"
                          : "notsale-preview-thumb"
                      }
                      onClick={() => setMainIndex(idx)}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
          <div
            className="notsale-preview-description mt-3"
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CollabProduct;
